import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import kebabCase from 'lodash/kebabCase'
import HTMLContainer from 'components/common/HTMLContainer/HTMLContainer'
import { dynamicDataAttribute } from 'helpers/utils'
import { getServiceIconName } from '../helpers'
import StoreServicesColumn from './StoreServicesColumn'
import ServiceTile from './ServiceTile'

const ServiceCategoriesList = ({
  title,
  description,
  storeServices,
  serviceCategories,
  storeBaseURL,
  updateServicesSection
}) =>
  <Wrapper>
    <ServiceCategoriesWrapper>
      <Title narrow>{ title }</Title>
      <DescriptionHTML content={ description } />
      {
        serviceCategories.map(({
          categoryId,
          categoryName,
          categoryDescription,
          storeServiceCategorySeo
        }) =>
          <ServiceTile
            key={ categoryId }
            iconName={ getServiceIconName(categoryId) }
            title={ categoryName }
            categoryId={ categoryId }
            description={ categoryDescription }
            url={ storeBaseURL + storeServiceCategorySeo }
            navigationHandler={ updateServicesSection } />
        )
      }
    </ServiceCategoriesWrapper>
    <StoreServicesColumnWrapper>
      {
        storeServices.map(({ serviceGroup, storeServices: items = [], serviceGroupDesc }, index) =>
          <StoreServicesGroupWrapper { ...dynamicDataAttribute('storeservices', kebabCase(serviceGroup)) } key={ index }>
            <StoreServicesColumn
              items={ items }
              header={ serviceGroup }
              description={ serviceGroupDesc } />
          </StoreServicesGroupWrapper>)
      }

    </StoreServicesColumnWrapper>
    <DisclaimerWrapper>
      Request an appointment online or come visit your local Big O Tires store today. We can’t wait to serve you!
      <StoreServicesSubText data-at-store-services-notice>
        *Services and Store Amenities vary by store, please call store for details.
      </StoreServicesSubText>
    </DisclaimerWrapper>
  </Wrapper>

export default ServiceCategoriesList

ServiceCategoriesList.propTypes = {
  description: PropTypes.string,
  serviceCategories: PropTypes.arrayOf(PropTypes.shape()),
  storeBaseURL: PropTypes.string,
  storeServices: PropTypes.arrayOf(PropTypes.shape()),
  title: PropTypes.string,
  updateServicesSection: PropTypes.func
}

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  .registered-mark {
    font-size: 10px;
    vertical-align: super;
  }
`

const Title = styled.h2`
  ${Mixin.font.GothamBold(19, 600)}
  text-transform: uppercase;
`

const DescriptionHTML = styled(HTMLContainer)`
  ${Mixin.font.GothamBook(14, 400)}
  ${Mixin.responsive('line-height', '18px', '22px')}
  ${Mixin.responsive('margin-bottom', '40px', '30px')}
`

const ServiceCategoriesWrapper = styled.div`
  ${Mixin.responsive('width', '60%', '100%')}
  ${Media.desktop`
    margin-right: 5%;
    flex: 350px;
  `}
`

const StoreServicesColumnWrapper = styled.div`
  ${Mixin.responsive('padding', '25px', '25px 10px')}
  background-color: ${Theme.colors.off_white};
  height: fit-content;
  ${Media.mobile`
    width: 100%;
  `}
`

const StoreServicesGroupWrapper = styled.div`
  ${Mixin.responsive('padding-bottom', '20px', '25px')}
`

const DisclaimerWrapper = styled.div`
  width: 100%;
`

const StoreServicesSubText = styled.span`
  line-height: 22px;
  display: block;
  margin-top: 15px;
`
